'use strict';

var Menu$1 = require('./src/Menu.js');
var MenuItem = require('./src/MenuItem.js');
var MenuItemGroup = require('./src/MenuItemGroup.js');

const Menu = Menu$1.Menu;
Menu.Item = MenuItem.MenuItem;
Menu.ItemGroup = MenuItemGroup.MenuItemGroup;

exports.Menu = Menu;
//# sourceMappingURL=index.js.map
